<template>
  <page-area v-if="loaded" />
</template>
<script>
  import Utils from '@/utils'
  import ModuleTransformer from '@transformers/ModuleTransformer'
  import ModuleGroupTransformer from '@transformers/ModuleGroupTransformer'
  import CourseTransformer from '@transformers/CourseTransformer'

  export default {
    name: 'Modulkonfigurator',
      // el: '#example-3',

    props: {},
    data () {
      return {
        mySomeValue: ['aaaa'],
        loaded: false,
        active: 0
      }
    },
    methods: {
        say: function (message) {
            alert(message)
        },

      load () {
        let self = this
        // eslint-disable-next-line
        let configuration = modulconfigurator
        // Utils.logger.log('loading items json...')
        // return new Promise((resolve, reject) => {
        return new Promise((resolve) => {
          Utils.logger.log('adding json to storage')

          if (configuration.hasOwnProperty('modulegroups')) {
            let modulegroups = Object.freeze(ModuleGroupTransformer.fetchCollection(configuration.modulegroups))
            self.$store.commit('SET_MODULEGROUPS', modulegroups)
            // Utils.logger.log('adding modulegroups to storage', modulegroups)
          }

          if (configuration.hasOwnProperty('modules')) {
            let modules = Object.freeze(ModuleTransformer.fetchCollection(configuration.modules))
            self.$store.commit('SET_MODULES', modules)
            // Utils.logger.log('adding modules to storage', modules)
          }

          if (configuration.hasOwnProperty('courses')) {
              let courses = Object.freeze(CourseTransformer.fetchCollection(configuration.courses))
              self.$store.commit('SET_COURSES', courses)
          }

          if (configuration.hasOwnProperty('programLists')) {
              let programListsTest = configuration.programLists[0]

              let programLists = configuration.programLists

              self.$store.commit('SET_PROGRAMLISTS', programLists)
          }

          resolve()
        })
      }
    },
    mounted() {
      const me = this
      me.load().then(() => {
        me.loaded = true
        // develop
        // me.loadFormByCourse('c1')
      })
    }
  }
</script>
